import { render, staticRenderFns } from "./EditarDadosTriagem.vue?vue&type=template&id=0e3d40e0&"
import script from "./EditarDadosTriagem.vue?vue&type=script&lang=js&"
export * from "./EditarDadosTriagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports